/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BaseReportDTO,
    BaseReportDTOFromJSON,
    BaseReportDTOFromJSONTyped,
    BaseReportDTOToJSON,
} from './BaseReportDTO';

/**
 * 
 * @export
 * @interface BaseReportDTOPagedResponse
 */
export interface BaseReportDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof BaseReportDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseReportDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseReportDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<BaseReportDTO>}
     * @memberof BaseReportDTOPagedResponse
     */
    data?: Array<BaseReportDTO> | null;
}

export function BaseReportDTOPagedResponseFromJSON(json: any): BaseReportDTOPagedResponse {
    return BaseReportDTOPagedResponseFromJSONTyped(json, false);
}

export function BaseReportDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseReportDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(BaseReportDTOFromJSON)),
    };
}

export function BaseReportDTOPagedResponseToJSON(value?: BaseReportDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(BaseReportDTOToJSON)),
    };
}

